/* istanbul ignore file */
/* eslint-disable */

export const responsiveProperties = {
  mobileBreakpoint: 600,
  tabletBreakpoint: 1024,
};
export const MOUNT_NODE = 'event-ui-portal';
